import { render, staticRenderFns } from "./sendmoney-beneficiary-list.vue?vue&type=template&id=961c89f8&"
import script from "./sendmoney-beneficiary-list.vue?vue&type=script&lang=js&"
export * from "./sendmoney-beneficiary-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports